import React, { useEffect, useState } from "react";
import firebase from "./firebase";
import "firebase/storage";
import "firebase/database";
type ContextProps = {
  user: firebase.User | null;
  authenticated: boolean;
  setUser: any;
  setRoute: any;
  loadingAuthState: boolean;
  getImageUrl(bucketName: string, fileName: string): Promise<string>;
  getDatabase(): firebase.database.Database;
  pageName: string;
};
export const AuthContext = React.createContext<Partial<ContextProps>>({});
export const AuthProvider = ({ children }: any) => {
  const [user, setUser] = useState(null as firebase.User | null);
  const [pageName, setRoute] = useState("");
  const [loadingAuthState, setLoadingAuthState] = useState(true);
  const storage = firebase.storage();
  const database = firebase.database();
  const getDatabase = (): firebase.database.Database => {
    return database;
  };

  const startRefreshTimer = (user: any) => {
    let minutes = 59;
    let seconds = minutes * 60;
    let tokenRefreshTime = 1000 * seconds;

    let token = null;

    var timerHandle = setTimeout(function () {
      token = user.getIdToken(true);
      resetTimer();
    }, tokenRefreshTime);

    //the function is called after a token has been refreshed.
    function resetTimer() {
      window.clearTimeout(timerHandle);
      timerHandle = setTimeout(function () {
        alert("The token is being refreshed");
        token = user.getIdToken(true);
        //TODO: double check it isnt a mistake putting this here
        resetTimer();
      }, tokenRefreshTime);
    }
  };
  const getImageUrl = async (
    bucketName: string,
    fileName: string
  ): Promise<string> => {
    const images = storage.ref().child(bucketName);
    const image = images.child(fileName);
    let returnValue = "";
    await image
      .getDownloadURL()
      .then((url) => {
        returnValue = url;
      })
      .catch((err) => {
        return null;
      });
    return returnValue;
  };
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user: any) => {
      setUser(user);
      setLoadingAuthState(false);
      startRefreshTimer(user);
    });
  }, []);
  return (
    <AuthContext.Provider
      value={{
        user,
        authenticated: user !== null,
        setUser,
        setRoute,
        pageName,
        loadingAuthState,
        getImageUrl,
        getDatabase,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
